import { Component } from '@angular/core';
import { ModalPlayComponent } from '../modal-play/modal-play.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-hero-section',
    imports: [TranslateModule],
    templateUrl: './hero-section.component.html',
    styleUrl: './hero-section.component.scss'
})
export class HeroSectionComponent {
  constructor(public modal: MatDialog) {}

  playModalPlay(): void {
    const dialogRef = this.modal.open(ModalPlayComponent, {
      data: {
        videoUrl:
          'https://storage.googleapis.com/weayr-assets-non-prod/videos/CEiiA_AYR.mp4',
        poster: {
          webp: 'https://storage.googleapis.com/weayr-assets-non-prod/images/images/home/CEiiA_AYR_poster.webp',
          jpg: 'https://storage.googleapis.com/weayr-assets-non-prod/images/images/home/CEiiA_AYR_poster.jpg',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
    });
  }
}
